<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="Payment Method"
            bc3="Add"
            path="payment-method"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <ValidationObserver
                    ref="observer"
                    tag="form"
                    v-slot="{ invalid, validate }"
                  >
                    <form
                      class="form form-horizontal"
                      @submit.prevent="validate().then(sendCall)"
                    >
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="name-icon">Name</label>
                            </div>
                            <div class="col-sm-9">
                              <ValidationProvider
                                name="Name"
                                ref="name"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span class="input-group-text"
                                      ><i class="far fa-user"></i
                                    ></span>
                                  </div>

                                  <input
                                    type="text"
                                    v-model="name"
                                    id="name-icon"
                                    class="form-control"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                    name="name"
                                    placeholder="Name"
                                    v-validate="'required'"
                                  />
                                </div>
                                <small
                                  class="block text-red-600 text-xs absolute bottom-0 left-0"
                                  style="color:#EA5455"
                                  >{{ errors[0] }}</small
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3">
                              <label for="rate-icon">Enable Independent Settlement</label>
                            </div>
                            <div class="col-sm-9">
                              <input
                                class="custom-checkbox"
                                type="checkbox"
                                v-model="independentSettlement"
                                :true-value="1"
                                :false-value="0"
                                name="independentSettlement"
                              />
                            </div>
                          </div>
                        </div>
<!--                        <div class="col-12">-->
<!--                          <div class="form-group row">-->
<!--                            <div class="col-sm-3">-->
<!--                              <label for="rate-icon">Enable Settings</label>-->
<!--                            </div>-->
<!--                            <div class="col-sm-9">-->
<!--                              <input-->
<!--                                  class="custom-checkbox"-->
<!--                                  type="checkbox"-->
<!--                                  v-model="settingsCheckBox"-->
<!--                                  name="settingsCheckBox"-->
<!--                                  @change="ChangeSettingsCheckBox($event)"-->
<!--                              />-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <PaymentMethodConfigForm ref="paymentMethodSettings" :showSettings="settingsCheckBox" />-->
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3">
                              <label for="rate-icon"
                                >Add withdrawal fields
                              </label>
                            </div>
                            <div class="col-sm-9">
                              <input
                                class="custom-checkbox"
                                type="checkbox"
                                v-model="withdrawalCheckBox"
                                name="withdrawalCheckBox"
                                @change="
                                  ChangewithdrawalCheckBox(withdrawalCheckBox)
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-12" v-if="withdrawalCheckBox">
                          <div
                            class="added-field"
                            v-for="(field, index) in withdrawalFields"
                            :key="index"
                          >
                            <div class="col-12 text-right mb-2">
                              <button
                                type="button"
                                class="btn btn-danger mr-1"
                                @click="removeField(index)"
                              >
                                Delete
                              </button>
                            </div>
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3 col-form-label text-right">
                                  <label for="name-icon">Name</label>
                                </div>
                                <div class="col-sm-9">
                                  <ValidationProvider
                                    name="Name"
                                    ref="field.name"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text"
                                          ><i class="far fa-user"></i
                                        ></span>
                                      </div>
                                      <input
                                        type="text"
                                        v-model="field.Name"
                                        :key="index"
                                        class="form-control"
                                        name="field.Name"
                                        placeholder="Name"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                      />
                                    </div>
                                    <small
                                      class="block text-red-600 text-xs absolute bottom-0 left-0"
                                      style="color:#EA5455"
                                      >{{ errors[0] }}</small
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3 col-form-label text-right">
                                  <label for="name-icon">Type</label>
                                </div>
                                <div class="col-sm-9">
                                  <ValidationProvider
                                    name="Type"
                                    ref="field.type"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="input-group">
<!--                                      <div class="input-group-prepend">-->
<!--                                        <span class="input-group-text"-->
<!--                                          ><i class="far fa-edit"></i-->
<!--                                        ></span>-->
<!--                                      </div>-->
<!--                                      <input-->
<!--                                        type="text"-->
<!--                                        v-model="field.type"-->
<!--                                        class="form-control"-->
<!--                                        name="field.type"-->
<!--                                        :key="index"-->
<!--                                        v-validate="'required'"-->
<!--                                        placeholder="Type"-->
<!--                                        :class="errors[0] ? 'is-invalid' : ''"-->
<!--                                      />-->
                                      <b-form-select
                                          v-model="field.type"
                                          size="md"
                                          :class="errors[0] ? 'is-invalid' : ''"
                                          v-validate="'required'"
                                          name="field.type"
                                          class="mt-1"
                                      >
                                        <b-form-select-option value=""
                                        >Please Select Type
                                        </b-form-select-option>
                                        <b-form-select-option value="text">
                                          text
                                        </b-form-select-option>
                                        <b-form-select-option value="number">
                                          number
                                        </b-form-select-option>
                                      </b-form-select>
                                    </div>
                                    <small
                                      class="block text-red-600 text-xs absolute bottom-0 left-0"
                                      style="color:#EA5455"
                                      >{{ errors[0] }}</small
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group row align-items-center">
                                <div class="col-sm-3 col-form-label text-right">
                                  <label for="rate-icon">Is Required </label>
                                </div>
                                <div class="col-sm-9">
                                  <input
                                    class="custom-checkbox"
                                    type="checkbox"
                                    v-model="field.required"
                                    :true-value="1"
                                    :false-value="0"
                                    name="requiredCheckbox"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-12">
                            <div class="col-sm-6 offset-sm-3 mb-2">
                              <button
                                type="button"
                                class="btn btn-success mt-2 mr-1"
                                @click="addMoreField"
                              >
                                <i class="fa fa-plus"></i> Add Fields
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="col-sm-9 offset-sm-3 text-right d-flex">
                            <button
                              type="submit"
                              class="btn btn-primary mr-1 d-flex"
                              :disabled="loading"
                            >
                              <Loader :loading="loading" :size="size"></Loader>
                              Save
                            </button>
                            <button
                              type="button"
                              class="btn btn-gradient-secondary"
                              @click="$router.push({ name: 'payment-method' })"
                            >
                              Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import PaymentMethodConfigForm from "./PaymentMethodConfigForm.vue";

export default {
  components: {
    CommandIcon,
    ValidationObserver,
    ValidationProvider,
    PaymentMethodConfigForm
  },
  mounted() {},
  data() {
    return {
      name: "",
      independentSettlement: 0,
      withdrawalCheckBox: false,
      settingsCheckBox: false,
      Id: 0,
      withdrawalFields: [
        {
          type: "",
          Name: "",
          required: ""
        }
      ],
      loading: false,
      size: "10px"
    };
  },
  computed: {},
  methods: {
    ChangewithdrawalCheckBox() {
      if (this.withdrawalFields.length > 0) {
        this.withdrawalFields = [];
      }
    },
    ChangeSettingsCheckBox(event) {
      this.settingsCheckBox = event.target.checked;
    },
    addMoreField() {
      let params = {
        type: "",
        required: "",
        Name: ""
      };
      this.withdrawalFields.push(params);
    },
    removeField(index) {
      this.withdrawalFields.splice(index, 1);
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if(!this.withdrawalCheckBox){
            this.withdrawalFields = []
          }
          this.loading = true;
          
          // let rawData = this.$refs.paymentMethodSettings ? this.$refs.paymentMethodSettings.getSettingsData() : {};
          
          let data = {
            name: this.name,
            independentSettlement: this.independentSettlement,
            withdrawalFields: JSON.stringify(this.withdrawalFields)
          }
          
          // if(Object.keys(rawData).length > 0){
          //   data.settings = JSON.stringify(rawData);
          // }
          
          this.makeRequest("post", "v1/add-payment-method", data).then(
               callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("paymentMethod");
                    if (typeof storeData.firstPageData.data != "undefined") {
                      storeData.firstPageData.data.unshift(responseData);
                      storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                      if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                        storeData.firstPageData.data.pop();
                      }
                      storeData.key = "paymentMethod";
                      delete storeData.otherPageData;
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "payment-method",
                      // params: { add: true }
                    });
                  }
                } else {
                  this.loading = false;
                }
              }
            }
            //callResponse => {
            //  if (!callResponse.error) {
            //    let code = callResponse.response.data.code;
            //    if (code == 200) {
            //      this.loading = false;
            //      if (callResponse.response.data.data) {
            //        let responseData = callResponse.response.data.data;
            //        let storeData = this.$store.getters.getByKey(
            //          "paymentMethod"
            //        );
            //        console.log("firstpage", responseData);
            //        if (typeof storeData.firstPageData != "undefined") {
            //        //  storeData.firstPageData.data.unshift(responseData);
            //          //  storeData.firstPageData.data.pop();
            //          storeData.key = "paymentMethod";
            //          delete storeData.otherPageData;
            //          let storeData = this.$store.dispatch("set", storeData);
            //        }
            //        this.$router.push({
            //          name: "payment-method",
            //          params: { add: true }
            //        });
            //      }
            //    } else if (code == 400) {
            //      this.loading = false;
            //    }
            //  }
            //}
          );
        }
      });
    }
  }
};
</script>

